export enum Permission {
  Admin = 'admin_panel.legacy_permission',
}
